import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as Sentry from '@sentry/angular';
import { environment } from '../../../environments/environment';

export interface LinkClickPayload {
  url: string;
}

@Injectable({
  providedIn: 'root',
})
export class LinkClickTrackingService {
  private readonly apiBaseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  /**
   * Track a link click event (fire-and-forget)
   * POST /api/v1/chat/{conversation_id}/analytics/clicks
   */
  trackLinkClick(conversationId: string, url: string): void {
    const endpoint = `${this.apiBaseUrl}/api/v1/chat/${conversationId}/analytics/clicks`;
    const payload: LinkClickPayload = { url };

    this.http.post(endpoint, payload).subscribe({
      error: (err) => {
        Sentry.captureException(err, {
          tags: { feature: 'link-click-tracking' },
          extra: { conversationId, url },
        });
      },
    });
  }
}
